import React, { FunctionComponent } from 'react';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconBim360: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faDesktop} />;

export { BrassIconBim360 };
